import { PriceRangeType, PriceType, StateType } from 'data/types'
import messages from 'lang'
import isNil from 'lodash/isNil'
import { createSelector } from 'reselect'

const ranges: Array<PriceRangeType> = [
  {
    descriptor: { id: messages.short_x_minute, x: 1 },
    granularity: 60,
    value: '1m'
  },
  {
    descriptor: { id: messages.short_x_minute, x: 5 },
    granularity: 300,
    value: '5m'
  },
  {
    descriptor: { id: messages.short_x_minute, x: 15 },
    granularity: 900,
    value: '15m'
  },
  {
    descriptor: { id: messages.short_x_hour, x: 1 },
    granularity: 3600,
    value: '1h'
  },
  {
    descriptor: { id: messages.short_x_hour, x: 6 },
    granularity: 21600,
    value: '6h'
  },
  {
    descriptor: { id: messages.short_x_day, x: 1 },
    granularity: 86400,
    value: '1d'
  }
]
const defaultRange = ranges[5]

const getPrice = (state: StateType) => state.price

const getAll: (state: StateType) => Array<PriceType> = createSelector(
  getPrice,
  (price) => price.all
)

const getCurrentRange: (state: StateType) => PriceRangeType = createSelector(getPrice, (price) => {
  if (isNil(price.currentRange)) {
    return defaultRange
  }

  return ranges.find((range) => range.value === price.currentRange) || defaultRange
})

const getRanges: (state: StateType) => PriceRangeType[] = () => ranges

const getLiveCallback: (state: StateType) => void | ((update: PriceType) => void) = createSelector(
  getPrice,
  (price) => price.liveCallback
)

export default {
  getAll,
  getCurrentRange,
  getLiveCallback,
  getRanges
}
